import $ from 'jquery'
import PDFSettingsPreview from '../../../pdfSettingsPreview/PDFSettingsPreview'
import {ChartType} from '../../constants'
import {PaperOrientation} from '../../../pdf/constants'
import ListSelector from '../../../controls/ListSelector'
import makeRpcCall from '../../../util/jquery_rpc'
import CustomSettingsSection from './CustomSettingsSection'
import {getMaxValuesCalculator} from '../pdfgenerator/utils'
import ReportChartsStore from '../ReportChartsStore'

export default class ChartsPDFSettingsPreview extends PDFSettingsPreview {

    afterRender()
    {
        PDFSettingsPreview.prototype.afterRender.call(this);
        this.lastSavedPaperOrientation = this.getStore().getPrintParametersForSave().paperOrientation;

        this.customSettingsSection = new CustomSettingsSection(
                this.getCustomSettingsSectionContainer(),
                this.printParameters,
                this.lightboxId,
                this.changesCallback
        ).init();
    }

    update()
    {
        PDFSettingsPreview.prototype.update.call(this);
        this.customSettingsSection.update();
    }

    getStore()
    {
        return ReportChartsStore;
    }

    triggerIntermediatePrintParametersChange(newPrintParameters)
    {
        $(document).trigger("reportCharts.intermediatePrintParametersChange", newPrintParameters);
    }

    triggerPrintParametersForSaveChange(printParametersForSave)
    {
        $(document).trigger("reportCharts.printParametersForSaveChange", printParametersForSave);
    }

    /**
     * Show checkbox if there is data list and number of data values between maxOnPage and maxOnFitPage
     * or
     * if there is no data list but number of data points more than 2 * maxOnPage and chart type is not PIE(for pie without data only one page is used)
     * @param totalNumberOfPoints number of values in current chart
     */
    _updateFitDataCheckboxVisibility(totalNumberOfPoints)
    {
        const paperOrientation = this.chartType === ChartType.PIE_CHART ? PaperOrientation.PORTRAIT : this._getPaperOrientationParameter();
        const paperSize = this._getPaperSizeParameter();
        const {showHeaderOnEachPage} = super.collectPrintParametersForGenerate()

        const maxValuesCalculator = getMaxValuesCalculator(this.chartType)
        const maxValuesOnFitPage = maxValuesCalculator.getMaxValuesOnFitPage({
            paperOrientation,
            paperSize,
            showHeaderOnEachPage,
        })
        const maxValuesOnPage = maxValuesCalculator.getMaxValuesOnPage({
            paperOrientation,
            paperSize,
            showHeaderOnEachPage,
        })

        const tableIsShowed =
                this.customSettingsSection.showListOfDataValuesCheckbox.checked ||
                (this.customSettingsSection.showListOfPercentValuesCheckboxIsVisible
                        ? this.customSettingsSection.showListOfPercentValuesCheckbox.checked : false);

        /*
            show fit data to one page
               with table:
                  if values <= maxFittedValues
               without table:
                  if chart not PIE or if data more than possible for one page
         */
        let needToShowCheckBox
        if (tableIsShowed) {
            needToShowCheckBox = (totalNumberOfPoints > maxValuesOnPage && totalNumberOfPoints <= maxValuesOnFitPage)
        } else {
            if (this.chartType === ChartType.PIE_CHART) {
                needToShowCheckBox = false
            } else {
                needToShowCheckBox = totalNumberOfPoints > maxValuesCalculator.getMaxValuesOnPageWithoutTable({
                    paperOrientation, paperSize, showHeaderOnEachPage
                })
            }
        }

        // update fitted pages
        let fitToNPages = 1
        if (this.chartType === ChartType.HORIZONTAL_BAR && paperOrientation === PaperOrientation.LANDSCAPE && tableIsShowed) {
            fitToNPages = 2
        }
        this.customSettingsSection.setState({
            fitToNPages
        })

        if (needToShowCheckBox) {
            this.isfitDataCheckboxVisible = true
            this.section.removeClass("fitDataCheckboxHidden")
        }
        else {
            this.section.addClass("fitDataCheckboxHidden")
            this.isfitDataCheckboxVisible = false
        }
    }

    // this method removes old chart size selector from dom and initializes new selector according to current chart and print parameters
    _reinitializeChartSizeSelector(numberOfBars)
    {
        this.customSettingsSection.chartSizeSelectorContainer.innerHTML = "";

        const dataFitToOnePage = this._isFitDataToOnePage()

        const maxNumberOfBarsForCurrentChart = dataFitToOnePage ?
                                             this.totalNumberOfPoints :
                                             Math.min(this.totalNumberOfPoints, this.getMaxCountBarsOnPage());

        const initialValue = numberOfBars > 0 ? Math.min(numberOfBars, maxNumberOfBarsForCurrentChart) : maxNumberOfBarsForCurrentChart;

        const chartSizeItems = [];
        for (let i = 1; i <= maxNumberOfBarsForCurrentChart; i++)
            chartSizeItems.push({text: i, value: i});

        this.customSettingsSection.chartSizeSelector = new ListSelector({
            menuCls: "chartSizeSelectorMenu",
            renderTo: this.customSettingsSection.chartSizeSelectorContainer,
            listItems: chartSizeItems,
            value: dataFitToOnePage ? maxNumberOfBarsForCurrentChart : initialValue
        });
        this.customSettingsSection.chartSizeSelector.on("change", this.changesCallback);
        if (dataFitToOnePage)
        {
            this.customSettingsSection.chartSizeSelector.disable();
        }
    }

    handleParameterChange() {
        this._updateFitDataCheckboxVisibility(this.totalNumberOfPoints)

        if (this.chartType !== ChartType.PIE_CHART) {
            let numberOfBars = this.getCurrentChartSizeSelectorValue()
            // save previous value in selector if fit to one page checked
            if(this._isFitDataToOnePage() && this._prevFitDataToOnePage === false) {
                this.prevChartSizeValue = numberOfBars
            } else if(this._isFitDataToOnePage() === false) {
                if (this.prevChartSizeValue) {
                    numberOfBars = this.prevChartSizeValue
                    this.prevChartSizeValue = null
                }
            }
            this._reinitializeChartSizeSelector(numberOfBars)
        }
        this._prevFitDataToOnePage = this._isFitDataToOnePage()

        PDFSettingsPreview.prototype.handleParameterChange.call(this)
    }

    getCurrentChartSizeSelectorValue()
    {
        return this.customSettingsSection.chartSizeSelector.getSelectedItem().value;
    }

    getMaxCountBarsOnPage()
    {
        return getMaxValuesCalculator(this.chartType).getMaxValuesOnPage({
            paperOrientation: this._getPaperOrientationParameter(),
            paperSize: this._getPaperSizeParameter(),
            showHeaderOnEachPage: super.collectPrintParametersForGenerate().showHeaderOnEachPage
        })
    }

    collectPrintParametersForGenerate()
    {
        const printParameters = PDFSettingsPreview.prototype.collectPrintParametersForGenerate.call(this);
        if (this.chartType === ChartType.PIE_CHART)
            printParameters.paperOrientation = PaperOrientation.PORTRAIT;

        printParameters.showListOfDataValues = this.customSettingsSection.showListOfDataValuesCheckbox.checked;
        if (this.chartType !== ChartType.PIE_CHART)
        {
            printParameters.barsOnPage = this.getCurrentChartSizeSelectorValue();
        }
        printParameters.showListOfPercentValues = this.customSettingsSection.showListOfPercentValuesCheckboxIsVisible
                ? this.customSettingsSection.showListOfPercentValuesCheckbox.checked : false;
        printParameters.fitDataToOnePage = this._isFitDataToOnePage()

        return printParameters;
    }

    collectPrintParametersForSave()
    {
        const printParametersForSaving = PDFSettingsPreview.prototype.collectPrintParametersForSave.call(this);
        if (this.chartType === ChartType.PIE_CHART)
        {
            printParametersForSaving.paperOrientation = this.lastSavedPaperOrientation;
        }

        printParametersForSaving.showListOfDataValues = this.customSettingsSection.showListOfDataValuesCheckbox.checked;
        printParametersForSaving.showListOfPercentValues = this.customSettingsSection.showListOfPercentValuesCheckboxIsVisible
                ? this.customSettingsSection.showListOfPercentValuesCheckbox.checked : this.customSettingsSection.lastSavedShowListOfPercentValues;
        printParametersForSaving.fitDataToOnePage = this.isfitDataCheckboxVisible
                ? this.customSettingsSection.fitDataToOnePageCheckbox.checked : this.customSettingsSection.lastSavedFitDataToOnePage;

        return printParametersForSaving;
    }

    updateNeededLastSavedParameters()
    {
        const lastSavedPrintParameters = ReportChartsStore.getPrintParametersForSave();
        this.lastSavedPaperOrientation = lastSavedPrintParameters.paperOrientation;
        this.customSettingsSection.lastSavedShowListOfPercentValues = lastSavedPrintParameters.showListOfPercentValues;
        this.customSettingsSection.lastSavedFitDataToOnePage = lastSavedPrintParameters.fitDataToOnePage;
    }

    onShow(chartType, totalNumberOfPoints, numberOfBars, minValue, maxValue)
    {
        this.chartType = chartType;

        this.totalNumberOfPoints = totalNumberOfPoints;

        this._updateShowListOfPercentValuesCheckboxVisibility(minValue, maxValue);
        this._updateFitDataCheckboxVisibility(totalNumberOfPoints);

        if (this.chartType !== ChartType.PIE_CHART)
        {
            this._reinitializeChartSizeSelector(numberOfBars);
        }
    }

    _updateShowListOfPercentValuesCheckboxVisibility(minValue, maxValue)
    {
        if (minValue < 0 && maxValue > 0)
        {
            this.customSettingsSection.showListOfPercentValuesCheckboxIsVisible = false;
            this.section.addClass("percentCheckboxHidden");
        }
        else
        {
            this.customSettingsSection.showListOfPercentValuesCheckboxIsVisible = true;
            this.section.removeClass("percentCheckboxHidden");
        }
    }

    sendSaveChartPrintParametersRequest()
    {
        const self = this;
        makeRpcCall(
                "ReportChartService.saveChartPrintParameters",
                [ReportChartsStore.getPrintParametersForSave()],
                function() { self.updateNeededLastSavedParameters() },
                function() { return true; }
        );
    }

    _isFitDataToOnePage() {
        return this.isfitDataCheckboxVisible ? this.customSettingsSection.fitDataToOnePageCheckbox.checked : false
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfSettingsPreview/ChartsPDFSettingsPreview.js